<template>
	<div>
		<v-card color="secondary">
			<v-card-text>
				<v-layout
					align-center
					justify-center
					wrap
				>
					<v-flex  xs12 md3 pa-1 class="text-xs-center">
					</v-flex>
					<v-flex  xs12 md6 mt-1 pa-1>
						<v-text-field
							label="Search..."
							solo
							hide-details
							clearable
							v-model="searchText"
							@input="filterVouchers()"
						>
						</v-text-field>
					</v-flex>
					<v-flex  xs12 md3 pa-1 class="text-xs-center">
					</v-flex>
					<v-flex  xs12 md12 pa-1 class="text-xs-center">
						<v-btn @click="dialog = true"  color="primary" dark>issue voucher</v-btn>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
		<v-layout row wrap pa-3>
			<v-flex xs12>
				<v-flex xs12 sm12 md12>
					<div class="text-xs-center">
						<v-pagination
							v-model="currentPage"
							:length="pagesNumber"
							:total-visible="5"
							@input="updateVisible"
						></v-pagination>
					</div>
				</v-flex>
				<v-layout row wrap align-center>
					<v-flex v-for="v in visibleVouchers" :key="v.uid" xs12 pa-1>
						<v-card class="pa-3 elevation-4">
							<v-layout row wrap>
								<v-flex v-if="v.uid" xs6 md2>
									<div class="caption grey--text ">Voucher ID</div>
									<v-tooltip top>
										<span slot="activator">{{ v.uid | truncate(15, (v.uid.length>15 ? '..': '')) }}</span>
										<span>{{ v.uid }}</span>
									</v-tooltip>
								</v-flex>
								<v-flex v-if="v.name" xs6 md2>
									<div class="caption grey--text ">Client Name</div>
									<v-tooltip top>
										<span slot="activator">{{ v.name | truncate(15, (v.name.length>15 ? '..': '')) }}</span>
										<span>{{ v.name }}</span>
									</v-tooltip>
								</v-flex>
								<v-flex v-if="v.phone_number_1" xs6 md2>
									<div class="caption grey--text ">Client Phone</div>
									<v-tooltip top>
										<span slot="activator">{{ v.phone_number_1 | truncate(15, (v.phone_number_1.length>15 ? '..': '')) }}
											
										</span>
										<span>{{ v.phone_number_1 }}</span>
									</v-tooltip>
									<v-btn color="primary" 
										v-clipboard:copy="v.phone_number_1"
										v-clipboard:success="clipboardSuccessHandler"
										v-clipboard:error="clipboardErrorHandler"
										flat
										small
										icon
									>
										<v-icon >file_copy</v-icon>
									</v-btn>
								</v-flex>
								<v-flex v-if="v.issue_date" xs6 md2>
									<div class="caption grey--text ">Issue Date</div>
									<v-tooltip top>
										<span slot="activator">{{ v.issue_date | truncate(15, (v.issue_date.length>15 ? '..': '')) }}</span>
										<span>{{ v.issue_date }}</span>
									</v-tooltip>
								</v-flex>
								<v-flex v-if="v.expiry_date" xs6 md2>
									<div class="caption grey--text ">Expiry Date</div>
									<v-tooltip top>
										<span slot="activator">{{ v.expiry_date | truncate(15, (v.expiry_date.length>15 ? '..': '')) }}</span>
										<span>{{ v.expiry_date }}</span>
									</v-tooltip>
								</v-flex>
								<v-flex xs1>
									<v-tooltip top>
										<span slot="activator">
											<v-btn flat small icon color="primary" dark @click="viewOrder(v.order)">
												<v-icon >shopping_cart</v-icon>
											</v-btn>
										</span>
										<span>View Order</span>
									</v-tooltip>
									<v-tooltip top>
										<span slot="activator">
											<v-btn flat small icon color="error" dark @click="deleteV(v.uid)">
												<v-icon >close</v-icon>
											</v-btn>
										</span>
										<span>Delete Voucher</span>
									</v-tooltip>
								</v-flex>
								<v-flex xs1 :class="`${v.active? 'success' : 'error'} text-xs-center pa-1`">
									<span class="white--text headline">{{v.amount}}</span>
								</v-flex>
							</v-layout>
						</v-card>
					</v-flex>
				</v-layout>
				<v-flex xs12 sm12 md12>
					<div class="text-xs-center">
						<v-pagination
							v-model="currentPage"
							:length="pagesNumber"
							:total-visible="5"
							@input="updateVisible"
						></v-pagination>
					</div>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-layout row justify-center>
			<v-dialog v-model="dialog" persistent max-width="750">
				<v-card>
					<v-toolbar color="primary">
						<span class="headline white--text">Issue Voucher</span>
						<v-spacer></v-spacer>
						<v-btn @click="dialog = false" color="white" small flat icon>
							<v-icon>close</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<v-layout row wrap align-center>
							<v-flex xs11>
								<v-text-field
									label="Search for order..."
									solo
									hide-details
									clearable
									v-model="searchPhoneNumber"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs1>
								<v-btn icon small color="primary" flat @click="getLeadsBySearch()">
									<v-icon>search</v-icon>
								</v-btn>
							</v-flex>
							<v-divider></v-divider>
							<v-flex xs12 pt-3>
								<v-layout row wrap align-center> 
									<v-flex xs12 v-for="l in visibleLeads" :key="l.key">
										<v-card class="elevation-4 pa-2">
											<v-layout row wrap>
												<v-flex v-if="l.name" xs6 md3>
													<div class="caption grey--text ">Client Name</div>
													<v-tooltip top>
														<span slot="activator">{{ l.name | truncate(15, (l.name.length>15 ? '..': '')) }}</span>
														<span>{{ l.name }}</span>
													</v-tooltip>
												</v-flex>
												<v-flex v-if="l.phone_number_1" xs6 md3>
													<div class="caption grey--text ">Phone Number 1</div>
													<v-tooltip top>
														<span slot="activator">{{ l.phone_number_1 | truncate(15, (l.phone_number_1.length>15 ? '..': '')) }}</span>
														<span>{{ l.phone_number_1 }}</span>
													</v-tooltip>
												</v-flex>
												<v-flex v-if="l.import_date" xs6 md3>
													<div class="caption grey--text ">Date</div>
													<v-tooltip top>
														<span slot="activator">{{ l.import_date | truncate(15, (l.import_date.length>15 ? '..': '')) }}</span>
														<span>{{ l.import_date }}</span>
													</v-tooltip>
												</v-flex>
												<v-flex xs6 md3 class="text-xs-right" align-content-end>
													<v-tooltip top>
														<span slot="activator" class="text-x-right">
															<v-btn flat small icon color="primary" dark @click="goTo(/new-voucher/ + l.key)">
																<v-icon >receipt</v-icon>
															</v-btn>
														</span>
														<span>Issue Voucher</span>
													</v-tooltip>
												</v-flex>
											</v-layout>
										</v-card>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-dialog v-model="vdialog" v-if="lead" persistent max-width="750">
				<v-card>
					<v-toolbar color="primary">
						<span class="headline white--text">Order</span>
						<v-spacer></v-spacer>
						<v-btn @click="vdialog = false" color="white" small flat icon>
							<v-icon>close</v-icon>
						</v-btn>
					</v-toolbar>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-text-field
									label="Token"
									readonly
									v-model="lead.key"
									solo-inverted
									suffix="Order Token"
									:loading="loading"
									disabled
									light
									class="tokenField"
									color="white"
									background-color="primary"
								></v-text-field>
							</v-flex>
							<v-flex v-if="lead.name" xs6 md2>
								<div class="caption grey--text ">Client Name</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.name | truncate(10, (lead.name.length>10 ? '..': '')) }}</span>
									<span>{{ lead.name }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="lead.country" xs6 md2>
								<div class="caption grey--text ">Country</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.country | truncate(10, (lead.country.length>10 ? '..': '')) }}</span>
									<span>{{ lead.country }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="lead.phone_number_1" xs6 md2>
								<div class="caption grey--text ">Phone Number 1</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.phone_number_1 | truncate(10, (lead.phone_number_1.length>10 ? '..': '')) }}
										
									</span>
									<span>{{ lead.phone_number_1 }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="lead.import_date" xs6 md2>
								<div class="caption grey--text ">Date</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.import_date | truncate(15, (lead.import_date.length>15 ? '..': '')) }}</span>
									<span>{{ lead.import_date }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="lead.order_status" xs6 md2>
								<div class="caption grey--text ">Order Status</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.order_status  }}</span>
									<span>{{ lead.order_status }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="lead.total" xs6 md2>
								<div class="caption grey--text ">Order Total</div>
								<v-tooltip top>
									<span slot="activator">{{ lead.total  }}</span>
									<span>{{ lead.total }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs12 px-1 v-if="lead" elevation-5 pa-3 my-3>
								<v-layout row wrap>
									<v-flex xs12 v-for="item in lead.order" :key="lead.key+item">
										<v-layout row wrap>
											<v-flex v-if="item.sku" xs6 md2>
												<div class="caption grey--text ">Product SKU</div>
												<v-tooltip top>
													<span slot="activator">{{ item.sku }}</span>
													<span>{{ item.sku}}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="item.product" xs6 md2>
												<div class="caption grey--text ">Product Name</div>
												<v-tooltip top>
													<span slot="activator">{{ item.product | truncate(15, (item.product.length>15 ? '..': '')) }}</span>
													<span>{{ item.product}}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="item.price" xs6 md2>
												<div class="caption grey--text ">Price Name</div>
												<v-tooltip top>
													<span slot="activator">{{ item.price | truncate(8, (item.price.length>8 ? '..': '')) }}</span>
													<span>{{ item.price}}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="item.baseprice" xs6 md2>
												<div class="caption grey--text ">Base Price $</div>
												<v-tooltip top>
													<span slot="activator">{{ item.baseprice }}</span>
													<span>{{ item.baseprice}}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="item.discount" xs6 md2>
												<div class="caption grey--text ">Discount</div>
												<v-tooltip top>
													<span slot="activator">{{ item.discount }}</span>
													<span>{{ item.discount}}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="item.quantity" xs6 md2>
												<div class="caption grey--text ">Quantity</div>
												<v-tooltip top>
													<span slot="activator">{{ item.quantity }}</span>
													<span>{{ item.quantity}}</span>
												</v-tooltip>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
import {firebase, db, auth, storageRef, store } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';

export default {
	data() {
    return {
			loading:false,
			searchText:null,
			vouchers:[],
			filteredVouchers:[],
			visibleVouchers:[],
			currentPage: 1,
      pageSize: 10,
			pagesNumber:0,
			dialog:false,
			vdialog:false,
			visibleLeads:[],
			searchPhoneNumber:null,
			leadKey:null,
			lead:null,
		}
	},
	methods:{
		async deleteV(uid){
			let n = this.vouchers.findIndex(x=>x.uid == uid)
			console.log(this.vouchers.splice(n, 1))
			this.loading = true
			await db.ref('vouchers')
			.update({
				[uid]:null
			})
			this.filterVouchers()
		},
		async viewOrder(key){
			// this.lead = await db.ref(`leads/${key}`).once('value').then(x=>x.val())
			this.lead = await store.collection(`leads`).doc(token).get().then(x=>x.data())
			this.lead.key = key
			this.vdialog = true
		},
		async getVouchers(){
			let vouchers = await db.ref('vouchers').once('value').then(x=>x.val())
			for (const key in vouchers) {
				if (vouchers.hasOwnProperty(key)) {
					const v = vouchers[key];
					this.vouchers.push(v)
				}
			}
			this.filterVouchers()
		},
		genToken() {
      this.loading = true
      let vtoken = `ASH_V_${randomString(8, 'aA#')}`
      this.token = vtoken
			this.loading = false
			console.log(vtoken)
			return vtoken
		},
		goTo(path) {
      this.$router.push(path)
		},
		updateVisible() {
      this.sortByDate()
      this.visibleVouchers = this.filteredVouchers.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredVouchers = this.filteredVouchers.sort(function(a,b){
        return new Date(b.issue_date) - new Date(a.issue_date);
      });
    },
    getPagesNumber(){
      if (this.filteredVouchers.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredVouchers.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredVouchers.length / this.pageSize) + 1
      }
		},
		filterVouchers() {
      this.loading = true
			this.filteredVouchers = this.vouchers
			.filter(v=>{
				if(!this.searchText) return v
				for (const key in v) {
					if (v.hasOwnProperty(key)) {
						const val = v[key];
						if(val && typeof val == 'string' && val.toLowerCase().includes(this.searchText.toLowerCase())) return v
					}
				}
			})
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
		},
		async getLeadsBySearch() {
      this.loading = true
      this.visibleLeads = []
      let search = this.searchPhoneNumber
      console.log(search);
      if(!search || search == '') {
        this.loading = false
        return true
			}
			let leads1 = await store.collection('leads')
      .where('phone_number_1', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads2 = await store.collection('leads')
      .where('phone_number_1', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads3 = await store.collection('leads')
      .where('phone_number_1', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      console.log('search store', leads1)
      // let leads1 = await db.ref('leads')
      //   .orderByChild('phone_number_1')
	    //   .equalTo(search)
      //   .once('value')
      //   .then(x=>x.val())
      // let leads2 = await db.ref('leads')
      //   .orderByChild('phone_number_2')
	    //   .equalTo(search)
      //   .once('value')
      //   .then(x=>x.val())
      // let leads3 = await db.ref('leads')
      //   .orderByChild('phone_number_3')
	    //   .equalTo(search)
      //   .once('value')
      //   .then(x=>x.val())
			let leads = {...leads1, ...leads2, ...leads3}
			for (const key in leads) {
				if (leads.hasOwnProperty(key)) {
					const lead = leads[key];
					// lead.key = key
					let vindex = this.visibleLeads.findIndex(x => x.key === lead.key)
					if(vindex != -1) this.visibleLeads.splice(vindex, 1, lead); 
					if(vindex === -1) this.visibleLeads.push(lead)
				}
			}
      // await db.ref('leads')
      //   .orderByChild('phone_number_1')
	    //   .equalTo(search)
      //   .once('value')
      //   .then(snap=>{
      //     let leads = snap.val()
      //     console.log('leads', leads);
      //     for (const key in leads) {
      //       if (leads.hasOwnProperty(key)) {
      //         const lead = leads[key];
      //         lead.key = key
      //         let vindex = this.visibleLeads.findIndex(x => x.key === lead.key)
      //         if(vindex != -1) this.visibleLeads.splice(vindex, 1, lead); 
      //         if(vindex === -1) this.visibleLeads.push(lead)
      //       }
      //     }
			// 	})
			// await db.ref('leads')
      //   .orderByChild('phone_number_2')
	    //   .equalTo(search)
      //   .once('value')
      //   .then(snap=>{
      //     let leads = snap.val()
      //     console.log('leads', leads);
      //     for (const key in leads) {
      //       if (leads.hasOwnProperty(key)) {
      //         const lead = leads[key];
      //         lead.key = key
      //         let vindex = this.visibleLeads.findIndex(x => x.key === lead.key)
      //         if(vindex != -1) this.visibleLeads.splice(vindex, 1, lead); 
      //         if(vindex === -1) this.visibleLeads.push(lead)
      //       }
      //     }
      //   })
      // await db.ref('leads')
        // .orderByChild('phone_number_3')
	      // .equalTo(search)
        // .once('value')
        // .then(snap=>{
        //   let leads = snap.val()
        //   console.log('leads', leads);
        //   for (const key in leads) {
        //     if (leads.hasOwnProperty(key)) {
        //       const lead = leads[key];
        //       lead.key = key
        //       let vindex = this.visibleLeads.findIndex(x => x.key === lead.key)
        //       if(vindex != -1) this.visibleLeads.splice(vindex, 1, lead); 
        //       if(vindex === -1) this.visibleLeads.push(lead)
        //     }
        //   }
				// })
      this.loading = false
    },
	},
	created(){
		this.getVouchers()
		console.log(getCDate())

	}
}
</script>

<style scoped>

</style>
